import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAccessToken } from "@/lib/api";
import { useAuth } from "@/auth/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      } catch (e) {
        navigate("/login?error=oauth_failed");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="text-sm tracking-[0.2em] uppercase text-zinc-500">Signing you in…</div>
    </div>
  );
}
